// extracted by mini-css-extract-plugin
export default {"answers":"Answers_answers__3UVh9","answer":"Answers_answer__fjlCo","correct":"Answers_correct__C4GNe","wrong":"Answers_wrong__aZFDu"};